import axios from 'axios';
import { isByokActive, geminiText, geminiMultimodal } from './geminiByokService';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Get characters for a project */
export async function getCharacters(projectId) {
  const { data } = await axios.get(`${API}/characters?project_id=${projectId}`);
  return data;
}

/** Create a new character */
export async function createCharacter(characterData) {
  const { data } = await axios.post(`${API}/characters`, characterData);
  return data;
}

/** Update a character — accepts full character data object */
export async function updateCharacter(characterId, characterData) {
  const { data } = await axios.put(`${API}/characters/${characterId}`, characterData);
  return data;
}

/** Auto-detect characters from script */
export async function detectCharacters(projectId) {
  const { data } = await axios.post(`${API}/characters/${projectId}/detect`, {});
  return data;
}

/** Get version history for a character */
export async function getCharacterVersions(characterId) {
  const { data } = await axios.get(`${API}/characters/${characterId}/versions`);
  return data;
}

/** Save a named version snapshot */
export async function createCharacterVersion(characterId, versionData) {
  const { data } = await axios.post(`${API}/characters/${characterId}/versions`, versionData);
  return data;
}

/** Restore a character to a previous version */
export async function restoreCharacterVersion(characterId, versionData) {
  const { data } = await axios.post(`${API}/characters/${characterId}/restore-version`, versionData);
  return data;
}

/** Generate a character reference sheet (AI) */
export async function generateCharacterSheet(characterId, sheetData) {
  if (isByokActive() && sheetData.description) {
    return await generateCharacterSheetByok(characterId, sheetData);
  }
  const { data } = await axios.post(`${API}/characters/${characterId}/generate-sheet`, sheetData);
  return data;
}

async function generateCharacterSheetByok(characterId, sheetData) {
  const systemPrompt = `You are a professional character designer and concept artist for film production. Generate a detailed character reference sheet.`;
  const userPrompt = `Generate a character reference sheet for:
Name: ${sheetData.name || 'Unknown'}
Description: ${sheetData.description}
${sheetData.age ? `Age: ${sheetData.age}` : ''}
${sheetData.traits ? `Traits: ${sheetData.traits}` : ''}

Create a professional character reference sheet showing the character from multiple angles (front, 3/4, side) with consistent design. The style should be ${sheetData.style || 'photorealistic'}, cinematic quality, suitable for film pre-production.`;

  const referenceImages = [];
  if (sheetData.reference_image) {
    referenceImages.push({ base64Data: sheetData.reference_image });
  }

  const { text, images } = await geminiMultimodal(systemPrompt, userPrompt, referenceImages);

  return {
    character_id: characterId,
    description: text,
    image: images[0]?.data || null,
    source: 'byok',
  };
}
